var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.59 3H20C20.5523 3 21 3.44772 21 4V6.5C21 6.77614 20.7761 7 20.5 7H18.63C18.4864 7.01056 18.3548 7.08369 18.27 7.2H18.22C18.0793 7.34052 18.0002 7.53115 18 7.73V9.49C18 9.76614 17.7761 9.99 17.5 9.99H15.72C15.5212 9.99017 15.3305 10.0693 15.19 10.21L14.93 10.47C14.7893 10.6105 14.7102 10.8012 14.71 11V11.72C14.7089 11.9823 14.6047 12.2337 14.42 12.42L13.54 13.3C13.8418 13.9943 13.9983 14.743 14 15.5C14 18.5376 11.5376 21 8.5 21C5.46243 21 3 18.5376 3 15.5C3 12.4624 5.46243 10 8.5 10C9.26157 9.99907 10.0147 10.1592 10.71 10.47L17.89 3.29C18.0763 3.10526 18.3277 3.0011 18.59 3ZM5.44 16.56C5.44 17.6646 6.33543 18.56 7.44 18.56C7.97043 18.56 8.47914 18.3493 8.85421 17.9742C9.22929 17.5991 9.44 17.0904 9.44 16.56C9.44 15.4554 8.54457 14.56 7.44 14.56C6.33543 14.56 5.44 15.4554 5.44 16.56Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.961a12945e0e0d2082b388dd90652216.svg";
export { ForwardRef as ReactComponent };